export class AzureVmInstanceRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vmName",
            "baseName": "vmName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vmSize",
            "baseName": "vmSize",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkInterface",
            "baseName": "networkInterface",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkInterfaceConfig",
            "baseName": "networkInterfaceConfig",
            "type": "NetworkInterfaceConfig",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<RestoreAzureInstanceDiskInput>",
            "format": ""
        },
        {
            "name": "startInstanceAfterRestore",
            "baseName": "startInstanceAfterRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "adeEncryption",
            "baseName": "adeEncryption",
            "type": "AdeRestoreEncryptionConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmInstanceRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
